export const clientDeleteSuccess = "Utilisateur supprimé avec succès";
export const clientDeleteFailed = "Échec de la suppression de l'utilisateur";

export const emailPasswordRecoveredSucess = "E-mail de récupération envoyé avec succès";
export const emailPasswordRecoveredFailed = "Échec de l'envoi de l'e-mail de récupération";
